import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetectorI18n from 'i18next-browser-languagedetector';

import { NAMESPACE_FALLBACK } from 'Jsx/Utils/transformKeys';

const languageDetectorI18n = new LanguageDetectorI18n(null, {
  // order and from where user language should be detected
  order: [
    'querystring',
    'cookie',
    'localStorage',
    'navigator',
    'htmlTag',
    'path',
    'subdomain',
  ],

  // keys or params to lookup language from
  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  // optional expire and domain for set cookie
  cookieMinutes: 10,

  // optional htmlTag with lang attribute, the default is:
  // htmlTag: document.documentElement,
});

i18n
  .use(languageDetectorI18n)
  .use(initReactI18next)
  .init({
    debug: false,
    // lng: 'es',
    fallbackLng: ['es', 'pt'],
    fallbackNS: NAMESPACE_FALLBACK,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false, // to support ssr
    },
  });

export default i18n;
